// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountUserController from "./account_user_controller"
application.register("account-user", AccountUserController)

import AdminController from "./admin_controller"
application.register("admin", AdminController)

import BannerController from "./banner_controller"
application.register("banner", BannerController)

import BannerFormController from "./banner_form_controller"
application.register("banner-form", BannerFormController)

import Dashboard__ChartController from "./dashboard/chart_controller"
application.register("dashboard--chart", Dashboard__ChartController)

import Dashboard__DashboardCardController from "./dashboard/dashboard_card_controller"
application.register("dashboard--dashboard-card", Dashboard__DashboardCardController)

import Dashboard__DisplacementController from "./dashboard/displacement_controller"
application.register("dashboard--displacement", Dashboard__DisplacementController)

import Dashboard__GaugeController from "./dashboard/gauge_controller"
application.register("dashboard--gauge", Dashboard__GaugeController)

import Dashboard__MapController from "./dashboard/map_controller"
application.register("dashboard--map", Dashboard__MapController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import DataController from "./data_controller"
application.register("data", DataController)

import DeviceGroupController from "./device_group_controller"
application.register("device-group", DeviceGroupController)

import DevicesController from "./devices_controller"
application.register("devices", DevicesController)

import DisplacementController from "./displacement_controller"
application.register("displacement", DisplacementController)

import FormController from "./form_controller"
application.register("form", FormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistogramController from "./histogram_controller"
application.register("histogram", HistogramController)

import Modal__DisplacementController from "./modal/displacement_controller"
application.register("modal--displacement", Modal__DisplacementController)

import Modal__HistogramController from "./modal/histogram_controller"
application.register("modal--histogram", Modal__HistogramController)

import Modal__VerticalDisplacementController from "./modal/vertical_displacement_controller"
application.register("modal--vertical-displacement", Modal__VerticalDisplacementController)

import NotificationsCenterController from "./notifications_center_controller"
application.register("notifications-center", NotificationsCenterController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import SiteLocationController from "./site_location_controller"
application.register("site-location", SiteLocationController)

import StatisticsController from "./statistics_controller"
application.register("statistics", StatisticsController)

import SummernoteController from "./summernote_controller"
application.register("summernote", SummernoteController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UserController from "./user_controller"
application.register("user", UserController)

import UserPreferencesController from "./user_preferences_controller"
application.register("user-preferences", UserPreferencesController)

import VerticalDisplacementController from "./vertical_displacement_controller"
application.register("vertical-displacement", VerticalDisplacementController)
